"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SoundcloudIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.435 12.22A2.565 2.565 0 1012.4 7.308a4.104 4.104 0 00-5.595-3.524.477.477 0 00-.293.45v6.96c0 .566.46 1.026 1.026 1.026h5.898zM5.229 4.936a.41.41 0 01.82 0v6.873a.41.41 0 01-.82 0V4.936zM3.895 6.84a.41.41 0 11.82 0v4.97a.41.41 0 01-.82 0V6.84zm-1.231-.615a.41.41 0 01.82 0v5.482a.41.41 0 11-.82 0V6.225zm-1.33 1.686a.41.41 0 11.82 0v3.796a.41.41 0 11-.82 0V7.91zM0 8.424a.41.41 0 01.82 0v2.257a.41.41 0 01-.82 0V8.424z"
  })))
});
SoundcloudIcon.displayName = 'SoundcloudIcon';
var _default = exports.default = SoundcloudIcon;